import React from "react";
import { Star, BadgeCheck } from "lucide-react";
import { TESTIMONIALS, REVIEW_STATS } from "../mock";

function Card({ t }) {
  return (
    <div className="glass-card rounded-2xl p-6 w-[340px] shrink-0 mx-3">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-full grid place-items-center font-bold text-white text-sm" style={{ background: "linear-gradient(135deg,#2e9bff,#1877e6)" }}>{t.initials}</div>
        <div>
          <p className="text-white font-semibold text-sm">{t.name}</p>
          <p className="text-slate-500 text-xs">{t.loc}</p>
        </div>
        <span className="ml-auto text-slate-500 text-[11px]">{t.ago}</span>
      </div>
      <div className="flex gap-0.5 mt-4">{[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-[#2e9bff] text-[#2e9bff]" />)}</div>
      <h4 className="text-white font-semibold mt-3">{t.title}</h4>
      <p className="text-slate-400 text-sm mt-2 leading-relaxed line-clamp-4">{t.body}</p>
      <span className="inline-flex items-center gap-1.5 mt-4 text-[11px] text-[#22e39a]"><BadgeCheck className="w-3.5 h-3.5" /> Verified Purchase</span>
    </div>
  );
}

export default function Testimonials() {
  const row1 = TESTIMONIALS.slice(0, 6);
  const row2 = TESTIMONIALS.slice(6, 12);
  return (
    <section className="py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center reveal">
        <h2 className="font-display text-4xl lg:text-5xl font-bold text-white">Trusted by <span className="text-blue-grad">Thousands</span><br className="hidden lg:block" /> of Traders</h2>
        <div className="flex items-center justify-center gap-3 mt-6">
          <div className="flex gap-0.5">{[...Array(5)].map((_, i) => <Star key={i} className={`w-5 h-5 ${i < 4 ? "fill-[#2e9bff] text-[#2e9bff]" : "fill-[#2e9bff]/40 text-[#2e9bff]/40"}`} />)}</div>
          <span className="text-white font-semibold">{REVIEW_STATS.avg} out of 5</span>
          <span className="text-slate-400 text-sm">Based on {REVIEW_STATS.total} reviews</span>
        </div>
        <div className="flex items-center justify-center gap-6 mt-4 text-sm">
          {REVIEW_STATS.breakdown.map((b) => (
            <span key={b.s} className="flex items-center gap-1.5 text-slate-400">{b.s} <Star className="w-3.5 h-3.5 fill-[#2e9bff] text-[#2e9bff]" /> {b.c}</span>
          ))}
        </div>
      </div>

      <div className="mt-14 space-y-6">
        <div className="flex animate-ticker w-max" style={{ animationDuration: "55s" }}>
          {[...row1, ...row1].map((t, i) => <Card key={i} t={t} />)}
        </div>
        <div className="flex animate-ticker w-max" style={{ animationDuration: "65s", animationDirection: "reverse" }}>
          {[...row2, ...row2].map((t, i) => <Card key={i} t={t} />)}
        </div>
      </div>
    </section>
  );
}
